import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import "Pagination.scss"

const Pagination = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  columns,
  selectRow,
  noDataIndication,
  keyField,
  hover,
  loading,
  expandRow,
}) => (
  <div>
    <PaginationProvider
      pagination={paginationFactory({
        custom: true,
        page,
        sizePerPage,
        totalSize,
      })}
    >
      {({ paginationProps, paginationTableProps }) => (
        <div>
          <BootstrapTable
            remote
            keyField={keyField}
            selectRow={selectRow}
            data={data}
            columns={columns}
            onTableChange={onTableChange}
            noDataIndication={noDataIndication}
            // wrapperClasses="table-responsive"
            hover={hover}
            loading={loading}
            {...paginationTableProps}
            expandRow={expandRow}
          />
          <div className="d-flex justify-content-start">
            <PaginationListStandalone {...paginationProps} />
          </div>
        </div>
      )}
    </PaginationProvider>
  </div>
);

export default Pagination;
